import { render, staticRenderFns } from "./EmailCreatedSuccess.vue?vue&type=template&id=da4a78ac&scoped=true"
import script from "./EmailCreatedSuccess.vue?vue&type=script&lang=js"
export * from "./EmailCreatedSuccess.vue?vue&type=script&lang=js"
import style0 from "./EmailCreatedSuccess.vue?vue&type=style&index=0&id=da4a78ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4a78ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da4a78ac')) {
      api.createRecord('da4a78ac', component.options)
    } else {
      api.reload('da4a78ac', component.options)
    }
    module.hot.accept("./EmailCreatedSuccess.vue?vue&type=template&id=da4a78ac&scoped=true", function () {
      api.rerender('da4a78ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/EmailCreatedSuccess.vue"
export default component.exports